import { FC } from "react";
import EmployeeForm from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/EmployeeEmployment/forms/EmployeeForm";
import { PermissionsContextProvider } from "src/utils/Permissions/PermissionsContext";

interface IEmployeeEmployment {
  employeeId: string;
  companyId: string;
  setIsEdited?: (isEdited: boolean, callback?: () => void) => void;
  active?: boolean;
}

const EmployeeEmployment: FC<IEmployeeEmployment> = ({
  employeeId,
  companyId,
  setIsEdited = () => null,
  active = false,
}) => {
  if (!active) {
    return null;
  }

  return (
    <PermissionsContextProvider>
      <EmployeeForm
        employeeId={employeeId}
        companyId={companyId}
        setIsEdited={setIsEdited}
      />
    </PermissionsContextProvider>
  );
};

export default EmployeeEmployment;
